import { Input, TextInputProps } from 'imaginarity-react-ui';
import * as React from 'react';
import { BaseEditItem } from '../GeneralPostEdit';
import { useGPEState } from '../Helpers/UseGPEState';
export interface EditNumberWithSliderProps<T> extends TextInputProps {
    getter: (value: T) => number | undefined;
    min?: number;
    max?: number;
    step?: number;
}

const EditNumber = <T extends BaseEditItem = BaseEditItem>(props: EditNumberWithSliderProps<T>) => {
    const { getter, min, max, step } = props;
    const { value: val, setValue: setVal } = useGPEState(getter);

    const setCVal = React.useMemo(() => (val: string | undefined) => {
        setVal(Number(val));
    }, [setVal]);

    React.useEffect(() => {
        if (min !== undefined && (val === undefined || val < min)) {
            setVal(min);
        } else if (max !== undefined && (val === undefined || val > max)) {
            setVal(max);
        }
    }, [max, min, setVal, val]);
    return (
        <Input type="number"
            value={val === undefined ? '' : val}
            step={step}
            change={setCVal}
            debounce={500}
        />
    );
}

export default EditNumber;
